export default {"src":"/_next/static/media/constLogo5.774cc471.svg","height":65,"width":244,"blurWidth":0,"blurHeight":0};